<template>
  <list-item v-if="show" data-cy="tax-info">
    <template slot="left">
      <div class="confirm-purchase__left">
        <small class="mr-4 text-grey-50">{{
          taxInfo && taxInfo.is_exact
            ? $t("components.checkout.taxInfo.tax")
            : $t("components.checkout.taxInfo.estTax")
        }}</small>
      </div>
    </template>

    <div v-if="isLoading" class="confirm-purchase__tax-loading opacity-40 pl-3">
      <placeholder-rect width="180px" class="m-0" height="30px" />
    </div>
    <template v-else-if="taxInfo">
      <div class="v-list-item__title pl-2">
        <template v-if="taxInfo.exclusive_tax_amount == 0">
          <small class="text-grey-50">{{
            $t("components.checkout.taxInfo.noTax")
          }}</small>
        </template>
        <template v-else>
          {{ taxInfo.symbol || "$" }}{{ taxInfo.exclusive_tax_amount }}
          {{ taxInfo.currency }}
          <small v-if="taxInfo.description" class="text-grey-50"
            >({{ taxInfo.description }})</small
          >
        </template>
      </div>
      <div v-if="noCouponTaxInfo" class="v-list-item__title pl-2 text-grey-60">
        <small>
          {{ $t("components.checkout.taxInfo.then") }}
          <template v-if="noCouponTaxInfo.exclusive_tax_amount == 0">
            <small class="text-grey-50">{{
              $t("components.checkout.taxInfo.noTax")
            }}</small>
          </template>
          <template v-else>
            {{ noCouponTaxInfo.symbol || "$"
            }}{{ noCouponTaxInfo.exclusive_tax_amount }}
            {{ noCouponTaxInfo.currency }}
          </template>
        </small>
      </div>
    </template>
  </list-item>
</template>

<script>
import ListItem from "@/components/ListItem"
import PlaceholderRect from "@/components/PlaceholderRect"

export default {
  components: {
    ListItem,
    PlaceholderRect
  },

  props: {
    taxInfo: { type: Object, default: null },
    noCouponTaxInfo: { type: Object, default: null },
    isLoading: { type: Boolean, default: false }
  },

  computed: {
    show() {
      return (
        this.isLoading ||
        (this.taxInfo &&
          (this.taxInfo.exclusive_tax_amount > 0 ||
            (this.taxInfo.exclusive_tax_amount === 0 &&
              !this.taxInfo.has_inclusive_tax)))
      )
    }
  }
}
</script>
